import { useEffect, useState } from "react";
import { fetchMyEventRegistration } from "@/api/registrations";
import type { ParticipationPaymentStatus } from "@/api/payments";

/** Best-effort read-only identity (solo/team + members + payment + the caller's
 *  own participation id) for the rest state of a registered card. One fetch
 *  serves both the header pill and the Pay/Support dialogs. Re-fetches when
 *  `refreshKey` changes. */
export function useRegistrationIdentity(
  eventId: number,
  personId: number,
  refreshKey: number,
) {
  const [identity, setIdentity] = useState<{
    category: "solo" | "team";
    teamName: string | null;
    participationId: number;
    canEdit: boolean;
    members: { person_id: number; first_name: string | null; last_name: string | null; is_free: boolean; payment_status: ParticipationPaymentStatus }[];
  } | null>(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const reg = await fetchMyEventRegistration(eventId, personId);
        if (cancelled || !reg) return;
        setIdentity({
          category: reg.category,
          teamName: reg.team_name,
          participationId: reg.participation_id,
          canEdit: reg.can_edit,
          members: reg.members,
        });
      } catch { /* identity fetch is best-effort */ }
    })();
    return () => { cancelled = true; };
  }, [eventId, personId, refreshKey]);

  return identity;
}
